import app from 'app';

app.namespace.Model.ApplicationStateModel = Backbone.Model.extend({
  defaults: {
    _isBlocked: false,
  },

  blockNavigation() {
    this.set('_isBlocked', true);
  },

  enableNavigation() {
    this.set('_isBlocked', false);
  },

  isNavigationBlocked() {
    return this.get('_isBlocked');
  },
});

export default app.namespace.Model.ApplicationStateModel;
